"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyGradient = exports.normalizeGradientOrientation = exports.normalizeGradientColorStop = exports.isStripesGradient = exports.parseSolidGradient = exports.solidGradient = exports.parseGradient = exports.gradientFromAST = exports.verifiedExpandGradient = exports.divideColorStops = exports.expandGradient = void 0;
var tslib_1 = require("tslib");
var chroma_js_1 = tslib_1.__importDefault(require("chroma-js"));
var gradient_parser_1 = require("gradient-parser");
var stylable_shorthands_1 = require("./stylable-shorthands");
var property_parser_1 = require("./utils/css-utils/property-parser");
var GRADIENT_MATCHER = /\S+-gradient/;
// TODO: Type return value
function expandGradient(value, prop, fallbackProp) {
    var _a, _b;
    var gradientMatch = value.match(GRADIENT_MATCHER);
    if (gradientMatch && gradientMatch.index !== undefined) {
        var restOfValue = value.slice(gradientMatch.index + gradientMatch[0].length + 1);
        var gradientValue = "".concat(gradientMatch[0], "(").concat(restOfValue.slice(0, (0, stylable_shorthands_1.findEndOfClosure)(restOfValue)), ")");
        var valueWithoutGradient = value.replace(gradientValue, '').trim();
        var restOfProp = {};
        if (valueWithoutGradient) {
            try {
                restOfProp = (0, property_parser_1.expandShorthandCssProp)(fallbackProp, valueWithoutGradient);
            }
            catch (_c) {
                //
            }
        }
        try {
            return tslib_1.__assign(tslib_1.__assign({}, restOfProp), (_a = {}, _a[prop] = (0, gradient_parser_1.parse)(gradientValue)[0], _a));
        }
        catch (_d) {
            //
        }
    }
    try {
        return (0, property_parser_1.expandShorthandCssProp)(fallbackProp, value);
    }
    catch (_e) {
        //
    }
    return _b = {}, _b[fallbackProp] = value, _b;
}
exports.expandGradient = expandGradient;
function divideColorStops(astColorStops) {
    if (!astColorStops || astColorStops.length < 2) {
        return [];
    }
    var colorStops = [];
    for (var i = 0; i < astColorStops.length; i++) {
        var stop_1 = astColorStops[i];
        var length_1 = '';
        if (stop_1.length) {
            length_1 = "".concat(stop_1.length.value).concat(stop_1.length.type);
        }
        else {
            if (i === 0) {
                length_1 = '0%';
            }
            else if (i === astColorStops.length - 1) {
                length_1 = '100%';
            }
        }
        var normalizedColor = normalizeGradientColorStop(stop_1);
        var newColor = (0, chroma_js_1.default)(normalizedColor);
        var color = newColor.alpha() < 1 ? normalizedColor : newColor.hex('rgb');
        colorStops.push({ color: color, length: length_1 });
    }
    var rangeStart = -1;
    var rangeEnd = -1;
    for (var i = 0; i < colorStops.length; i++) {
        var length_2 = colorStops[i].length;
        if (length_2) {
            if (rangeStart === -1) {
                rangeStart = i;
            }
            else {
                rangeEnd = i;
                if (rangeEnd > rangeStart + 1) {
                    var rangeStartLength = parseFloat(colorStops[rangeStart].length);
                    var rangeEndLength = parseFloat(colorStops[rangeEnd].length);
                    var rangeLength = rangeEnd - rangeStart;
                    var fraction = (rangeEndLength - rangeStartLength) / rangeLength;
                    for (var j = 1; j < rangeLength; j++) {
                        colorStops[rangeStart + j].length = "".concat((rangeStartLength + fraction * j).toFixed(2), "%");
                    }
                }
                rangeStart = rangeEnd = -1;
            }
        }
    }
    return colorStops;
}
exports.divideColorStops = divideColorStops;
function verifiedExpandGradient(value) {
    if (!value) {
        return null;
    }
    var expandedGradient = expandGradient(value, 'background-image', 'background');
    if (expandedGradient.background !== undefined || expandedGradient['background-image'] === value) {
        return null;
    }
    var gradientAST = expandedGradient['background-image'];
    if (!gradientAST || !gradientAST.colorStops || gradientAST.colorStops.length < 2) {
        return null;
    }
    return expandedGradient;
}
exports.verifiedExpandGradient = verifiedExpandGradient;
function gradientFromAST(gradientAST) {
    var gradient = {
        type: gradientAST.type,
        colorStops: divideColorStops(gradientAST.colorStops),
        orientation: normalizeGradientOrientation(gradientAST.type, gradientAST.orientation),
        steps: -1,
    };
    return gradientAST.position && gradientAST.size
        ? tslib_1.__assign(tslib_1.__assign({}, gradient), { position: gradientAST.position, size: gradientAST.size }) : gradient;
}
exports.gradientFromAST = gradientFromAST;
function parseGradient(value) {
    var expanded = verifiedExpandGradient(value);
    if (expanded) {
        var backgroundImage = expanded['background-image'];
        var position = expanded['background-position'];
        var size = expanded['background-size'];
        var gradient = position && size ? tslib_1.__assign(tslib_1.__assign({}, backgroundImage), { position: position, size: size }) : backgroundImage;
        return gradientFromAST(gradient);
    }
    return null;
}
exports.parseGradient = parseGradient;
function solidGradient(value) {
    return "linear-gradient(".concat(value, ", ").concat(value, ")");
}
exports.solidGradient = solidGradient;
function parseSolidGradient(value) {
    if (!value || !value.startsWith('linear-gradient')) {
        return null;
    }
    var expanded = verifiedExpandGradient(value);
    if (!expanded) {
        return null;
    }
    var gradientAST = expanded['background-image'];
    var colorStops = gradientAST.colorStops.map(function (stop) { return normalizeGradientColorStop(stop); });
    if (gradientAST.type === 'linear-gradient' && colorStops.every(function (stop) { return stop === colorStops[0]; })) {
        return colorStops[0];
    }
    return null;
}
exports.parseSolidGradient = parseSolidGradient;
// TODO: isStepsGradient
function isStripesGradient(gradient) {
    return (gradient.type === 'repeating-linear-gradient' &&
        gradient.colorStops.length === 4 &&
        gradient.colorStops[0].length === '0%' &&
        gradient.colorStops[1].length.endsWith('px') &&
        gradient.colorStops[1].length.endsWith('px') &&
        gradient.colorStops[2].length.endsWith('px') &&
        gradient.colorStops[1].length === gradient.colorStops[2].length &&
        parseFloat(gradient.colorStops[2].length) <= parseFloat(gradient.colorStops[3].length) &&
        gradient.colorStops[0].color === gradient.colorStops[1].color &&
        gradient.colorStops[2].color === gradient.colorStops[3].color);
}
exports.isStripesGradient = isStripesGradient;
function normalizeGradientColorStop(colorStop) {
    switch (colorStop.type) {
        case 'hex':
            return "#".concat(colorStop.value);
        case 'rgb':
        case 'rgba':
            return "".concat(colorStop.type, "(").concat(colorStop.value.join(', '), ")");
    }
    if (colorStop.value === 'transparent') {
        return 'rgba(255, 255, 255, 0)';
    }
    return colorStop.value;
}
exports.normalizeGradientColorStop = normalizeGradientColorStop;
function normalizeGradientOrientation(type, orientation) {
    if (!orientation) {
        if (~type.indexOf('linear')) {
            return '180deg';
        }
        return 'ellipse at 50% 50%';
    }
    if (Array.isArray(orientation) && orientation.length !== undefined) {
        var shape = orientation[0].value;
        var atValue = orientation[0].at.value;
        var orientationStr = '';
        if (shape) {
            orientationStr = "".concat(shape, " ");
        }
        orientationStr += 'at ';
        var x = atValue.x, y = atValue.y;
        if (x.type === 'position-keyword') {
            var value = x.value;
            switch (value) {
                case 'top':
                    orientationStr += '50% 0%';
                    break;
                case 'bottom':
                    orientationStr += '50% 100%';
                    break;
                case 'left':
                    orientationStr += '0% 50%';
                    break;
                case 'right':
                    orientationStr += '100% 50%';
                    break;
                case 'center':
                    orientationStr += '50% 50%';
                    break;
                default:
                    orientationStr += value;
            }
        }
        else {
            orientationStr += "".concat(x.value).concat(x.type);
        }
        if (y) {
            orientationStr += " ".concat(y.value).concat(y.type);
        }
        return orientationStr;
    }
    if (orientation.type === 'directional') {
        switch (orientation.value) {
            case 'top':
                return '0deg';
            case 'right':
                return '90deg';
            case 'bottom':
                return '180deg';
            case 'left':
                return '270deg';
            default:
                return "to ".concat(orientation.value);
        }
    }
    return "".concat(orientation.value, "deg");
}
exports.normalizeGradientOrientation = normalizeGradientOrientation;
function stringifyGradient(gradient, useRepeat, typeOverride, orientationOverride) {
    if (useRepeat === void 0) { useRepeat = true; }
    if (gradient.colorStops.length === 0) {
        return 'white';
    }
    var orientation = orientationOverride !== undefined ? orientationOverride : gradient.orientation;
    orientation = orientation ? orientation + ', ' : '';
    var colors = gradient.colorStops.map(function (stop, index) {
        var length = stop.length;
        if (useRepeat && gradient.repeatData) {
            var lengthsIndex = index;
            if (gradient.repeatData.repeats === -1) {
                lengthsIndex = index < gradient.colorStops.length / 2 ? 0 : 1;
            }
            length = gradient.repeatData.lengths[lengthsIndex];
        }
        return "".concat(stop.color).concat(length ? ' ' + length : '');
    });
    if (useRepeat && gradient.repeatData && gradient.repeatData.repeats === -1) {
        colors.splice(0, 1);
        colors.splice(colors.length - 1, 1);
    }
    var positionSizeString = '';
    if (gradient.position && gradient.size) {
        positionSizeString = "".concat(gradient.position, "/").concat(gradient.size, " ");
    }
    return "".concat(positionSizeString).concat(typeOverride || gradient.type, "(").concat(orientation).concat(colors.join(', '), ")");
}
exports.stringifyGradient = stringifyGradient;
//# sourceMappingURL=stylable-gradient.js.map